import { RouteName } from "../RouteNames";

export const ordreDuJourRoutes = {
  name: RouteName.OrdreDuJourRoot,
  path: "ordre-du-jour",
  component: () =>
    import("@follaw-fr/views/side_menu_views/OrdreDuJourView.vue"),
  redirect: { name: RouteName.FeuilleVerte },
  children: [
    {
      name: RouteName.FeuilleVerte,
      path: "feuille-verte",
      component: () =>
        import("@follaw-fr/views/ordre-du-jour/FeuilleVerteView.vue"),
    },
    {
      name: RouteName.OrdreDuJour,
      path: "senat",
      component: () => import("@follaw-fr/views/ordre-du-jour/OJSenatView.vue"),
    },
  ],
};
